import { ApiQueries, useSettings, useTitle } from "daymap-react";
import PageHeader from "../../containers/pageheader/pageheader"
import { PageContainer } from "../../components/layout";
import Grid from '@mui/material/Grid';
import { Link, Skeleton, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

function MyDetails() {
    useTitle('My Details');
    const navigate = useNavigate();
    const { settings } = useSettings();
    const { data, isPending } = new ApiQueries.contact.getContact().ToQuery();

    if (!settings) return null;

    if (isPending)
        return <Stack>
            <Skeleton variant="text" width={100} />
            <Skeleton variant="text" width={100} sx={{ fontSize: '2rem'}} />
        </Stack>;

    const Field = ({ label, value }: { label: string; value?: string }) => (
        <Grid size={{ xs: 6, md: 4 }} >
            <Typography variant="caption" > {label} </Typography>
            <Typography variant="body2" > {value} </Typography>
        </Grid>
        );

    const FieldLarge = ({ label, value }: { label: string; value?: string; }) => (
    <Grid size={{ xs: 12}} >
        <Typography variant="caption" > {label} </Typography>
        <Typography variant="body2" > {value} </Typography>
    </Grid>
    );
    
    return <>
        <PageHeader title="My Details" /> 
        <PageContainer>
            <Grid container spacing={2}>
                <Field label="First Name" value={data!.Firstname} />
                <Field label="Surname" value={data!.Surname} />
                <Field label="Title" value={data!.Title} />
                <Field label="Home Phone" value={data!.PhoneHome} />
                <Field label="Mobile" value={data!.PhoneMob} />
                <Field label="Business Phone" value={data!.PhoneBus} />
                <FieldLarge label="Email" value={data!.Email} />
                <FieldLarge label="Address" value={data!.Address1} />
                <FieldLarge label="" value={data!.Address2} />
                <Field label="Town" value={data!.Town} />
                <Field label="Post Code" value={data!.PostCode} />
                <Field label="State" value={data!.State} />
                <Field label="Country" value={data!.Country} />
            </Grid>
            <Typography variant="body2" sx={{ paddingTop: 5 }}> If any of the above details are incorrect or out of date, please report this to{' '}
            {settings.Messaging.ParentsSchoolMessage ? (
                <Link component="button" variant="body2" onClick={() => navigate("/message/new/5")} sx={{ cursor: 'pointer' }} >
                School Administration
                </Link>
                ) : ('School Administration')
            }.
            </Typography>
        </PageContainer>
    </>
}

export default MyDetails;